import axios from "axios";

/** Quita espacios y slashes finales. baseURL debe ser solo el origen (sin /api). */
function normalizeBaseUrl(url) {
  if (!url || typeof url !== "string") return "";
  return url.trim().replace(/\/+$/, "");
}

export function getApiBaseUrl() {
  if (process.env.REACT_APP_BACKEND_URL) {
    return normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL);
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    if (hostname === "rrhh.spectra-metrics.com") {
      return "https://rrhh-api.spectra-metrics.com";
    }

    if (hostname.includes("spectra-metrics.com")) {
      return normalizeBaseUrl(`https://${hostname.replace("rrhh.", "rrhh-api.")}`);
    }

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:8001";
    }
  }

  return "https://rrhh-api.spectra-metrics.com";
}

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem('sf_access_token') ||
    localStorage.getItem('spectra_token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
